import Media from './media';

type Color = {
  background: string;
  font: string;
};

export class Button {
  color: Color;
  icon: Media | null;
  isCircle: boolean;
  text: string;
  transparent: boolean;
  width: string;

  constructor(props: any) {
    this.icon = props.icon ? new Media(props.icon) : null;
    this.isCircle = props.circle;
    this.text = props.text;
    this.transparent = props.transparent;
    this.width = props.shapeFixedWidth
      ? props.shapeFixedWidth + (props.shapeFixedWidthUnit || 'px')
      : '';

    this.color = {
      background: props.backgroundColor,
      font: props.fontIconColor
    };
  }
}

export default Button;
